import News from "./API/News";
import Org from "./API/Org";
import Chart from "./API/Chart";
import Market from "./API/Market";
import Company from "./API/Company";
import Statistic from "./API/Statistic";
import Report from "./API/Report";
import Analysis from "./API/Analysis";
import Growth from "./API/Growth";
import A from "./API/A";
import Momentum from "./API/Momentum";
import StockInvest from "./API/StockInvest";
import Portfolio from "./API/Portfolio";

const API = {
  Org: new Org(),
  News: new News(),
  Chart: new Chart(),
  Market: new Market(),
  Company: new Company(),
  Statistic: new Statistic(),
  Report: new Report(),
  Analysis: new Analysis(),
  Growth: new Growth(),
  A: new A(),
  Momentum: new Momentum(),
  StockInvest: new StockInvest(),
  Portfolio: new Portfolio(),
};

export default API
